import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy } from '@angular/core';
import { RepairPartSearchComponent } from '../../components/repair-part/repair-part-search/repair-part-search.component';
import { RepairPartGridComponent } from '../../components/repair-part/repair-part-grid/repair-part-grid.component';
import { RepairPartFilterComponent } from '../../components/repair-part/repair-part-filter/repair-part-filter.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { RouterLink, RouterModule } from '@angular/router';

import { RepairPartFilterForm } from '../../form-model/repair-part-filter.form.model';
import { RepairPartSearchTextForm } from '../../form-model/repair-part-search-text.form.model';
import { RepairPartService } from '../../services/repair-part.service';

@Component({
  selector: 'app-repair-part',
  templateUrl: './repair-part.component.html',
  styleUrls: ['./repair-part.component.scss'],
  imports: [
    RepairPartSearchComponent,
    RouterLink,
    RouterModule,
    RepairPartGridComponent,
    RepairPartFilterComponent,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairPartComponent implements OnDestroy {
  filterFormGroup = this.formBuilder.group({
    repairPartFilterForm: this.formBuilder.group<RepairPartFilterForm>({} as RepairPartFilterForm),
    repairPartSearchTextForm: this.formBuilder.group<RepairPartSearchTextForm>({} as RepairPartSearchTextForm),
  });

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly repairPartService: RepairPartService,
  ) {}

  ngOnDestroy(): void {
    this.repairPartService.setRepairPartFilterFormValue(null);
  }
}
